var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    borderStyle: 'solid',
    backgroundColor: 'transparent',
    borderWidth: `0 ${_vm.borderWidth} ${_vm.borderWidth} 0`,
    padding: _vm.width,
    cursor: 'pointer',
    transition: 'transform 300ms ease-in-out'
  }),on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }